import { useI18n } from "vue-i18n"
import {
  normalizeDigits,
  normalizeIntegerInput,
  normalizePhoneNumber,
  toNullableInteger,
} from "@/utils/numericInput"

export const useValidator = () => {
  const { t } = useI18n()

  const validatePassword = (password) => {
    if (password?.length < 8) {
      return t("Password must be at least 8 characters long.")
    }

    if (!/[A-Z]/.test(password)) {
      return t("Password must contain at least one uppercase letter.")
    }

    if (!/\d/.test(password)) {
      return t("Password must contain at least one digit.")
    }

    if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password)) {
      return t(
        "Password must contain at least one special character (!#$%^&*()_+[]:;<>,.?~)"
      )
    }

    return true
  }

  const isRequired = (value) => {
    if (isNullOrUndefined(value) || isEmptyArray(value) || value === false)
      return t("This field is required")

    return !!String(value).trim().length || t("This field is required")
  }

  const validateEmail = (email) => {
    if (isEmpty(email)) return true

    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (Array.isArray(email))
      return (
        email.every((val) => re.test(String(val))) ||
        t("The Email field must be a valid email")
      )

    return re.test(String(email)) || t("The Email field must be a valid email")
  }

  function isValidMobile(number) {
    if (isEmpty(number)) return true
    const cleaned = normalizePhoneNumber(number)
    const regex = /^09\d{9}$/

    return regex.test(cleaned) || "شماره موبایل باید ۱۱ رقم و با ۰۹ شروع شود."
  }

  function isValidPhone(number) {
    if (isEmpty(number)) return true
    const cleaned = normalizePhoneNumber(number)
    const regex = /^0(?!9)\d{10}$/

    return regex.test(cleaned) || "تلفن ثابت باید با کد شهر و در ۱۱ رقم وارد شود."
  }

  function isValidInteger(value) {
    if (isEmpty(value)) return true
    const normalized = normalizeDigits(value)

    if (!/^\d+$/.test(normalized)) return "این مقدار باید فقط شامل عدد باشد."

    return Number(normalized) <= 2147483647 || "عدد واردشده بیش از حد بزرگ است."
  }

  const urlValidator = (value) => {
    if (isEmpty(value)) return true
    const re =
      /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

    return re.test(String(value)) || "مسیر سایت نامعتبر است"
  }

  return {
    validatePassword,
    validateEmail,
    isRequired,
    isValidMobile,
    isValidPhone,
    isValidInteger,
    urlValidator,
    normalizeDigits,
    normalizeIntegerInput,
    normalizePhoneNumber,
    toNullableInteger,
  }
}
